"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentClipFromTime = getCurrentClipFromTime;
exports.getCurrentClipIndexFromTime = getCurrentClipIndexFromTime;

function getClipIndex(time, clips) {
  return clips.findIndex(function (clip, index) {
    return !clips[index + 1] || time >= clip.startTime && time < clips[index + 1].startTime;
  });
}

function getCurrentClipFromTime(time, clips) {
  return clips[getClipIndex(time, clips)];
}

function getCurrentClipIndexFromTime(time, clips) {
  return getClipIndex(time, clips);
}